export enum DashboardFormLabelsEnum {
  TITLE = 'All Disputes',
  MY_DISPUTES = 'My Disputes',
  MY_DISPUTES_TEMPLATE = 'My Disputes Template',
  OPEN_DISPUTES = 'Open Disputes',
  OPEN_DISPUTES_TEMPLATE = 'Open Disputes Template',
  HISTORICAL = 'Historical',
  HISTORICAL_TEMPLATE = 'Historical Template',
}
